import { render, staticRenderFns } from "./AvukatKimlikKartiCard.vue?vue&type=template&id=61914aa7&scoped=true"
import script from "./AvukatKimlikKartiCard.vue?vue&type=script&lang=ts"
export * from "./AvukatKimlikKartiCard.vue?vue&type=script&lang=ts"
import style0 from "./AvukatKimlikKartiCard.vue?vue&type=style&index=0&id=61914aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61914aa7",
  null
  
)

export default component.exports